var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Label, Input, Row } from 'reactstrap';
import { withFormik } from 'formik';
import { toast } from 'react-toastify';
import BasicModal from 'Comps/common/BasicModal';
import CustomerDetails from 'Comps/OrderForm/CustomerDetails';
import CustomerService from 'Utils/customer';
import LogService from 'Utils/log';
import OtoSpinner from 'Comps/common/OtoSpinner';
import { validateCustomerFields } from 'Comps/OrderForm/OrderFormHelpers';
var VerifyUserModal = function (props) {
    var _a = __read(useState(null), 2), customer = _a[0], setCustomer = _a[1];
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    var onError = props.onError, onSuccess = props.onSuccess;
    var _c = __read(useState(false), 2), showCodeInput = _c[0], setShowCodeInput = _c[1];
    var errors = props.errors, handleBlur = props.handleBlur, handleChange = props.handleChange, touched = props.touched, values = props.values;
    var sendCode = function () {
        var formattedValues = CustomerService.fromFormData(values);
        setLoading(true);
        return CustomerService.createCustomer(formattedValues)
            .then(function (customer) {
            setLoading(false);
            CustomerService.saveCustomerLocally(customer, false);
            setCustomer(customer);
            setShowCodeInput(true);
        })
            .catch(function (error) {
            setLoading(false);
            LogService.error('Web customer create POST error', error);
            toast.error('Wystąpił błąd poczas próby założenia konta');
        });
    };
    var verifyCode = function () {
        setLoading(true);
        return CustomerService.verifyCustomer(customer, values.smsCode)
            .then(function (data) {
            var customer = data.customer, success = data.success;
            setLoading(false);
            if (success) {
                CustomerService.saveCustomerLocally(customer, true);
                onSuccess(customer);
                toast.success('Weryfikacja przebiegła pomyślnie :)');
            }
            else {
                onError(false);
                toast.error('Podany kod jest nieprawidłowy');
            }
        })
            .catch(function (error) {
            setLoading(false);
            LogService.error('Web customer verify error', error);
            toast.error('Wystąpił błąd poczas próby weryfikacji konta. Upewnij się, że dane są wprowadzone poprawnie i spróbuj ponownie');
        });
    };
    var isAnyFieldInvalid = Object.keys(errors).length > 0;
    return (React.createElement(BasicModal, { header: "Zarejestruj si\u0119, aby u\u017Cy\u0107 ten kod rabatowy", toggle: onError },
        React.createElement(Row, null,
            React.createElement(CustomerDetails, { errors: errors, touched: touched, values: values, handleBlur: handleBlur, handleChange: handleChange })),
        showCodeInput && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "small my-2" }, "Super! Zosta\u0142 ostatni krok - wys\u0142ali\u015Bmy Tobie wiadomo\u015B\u0107 SMS z kodem weryfikacyjnym. Wpisz go poni\u017Cej:"),
            React.createElement(FormGroup, null,
                React.createElement(Label, null, "Kod weryfikacyjny"),
                React.createElement(Input, { className: "mw-200", name: "smsCode", value: values.smsCode, onChange: handleChange })))),
        loading ? (React.createElement(OtoSpinner, { center: true, className: "mt-2" })) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-center mt-2" },
                React.createElement(Button, { color: "primary", disabled: isAnyFieldInvalid, className: "cart-order-btn mt-0", type: "button", onClick: showCodeInput ? verifyCode : sendCode }, showCodeInput ? 'Zweryfikuj kod' : 'Załóż konto'))))));
};
VerifyUserModal.propTypes = {
    initialValues: PropTypes.object.isRequired,
    onError: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};
var mapPropsToValues = function (props) {
    var initialValues = props.initialValues;
    var customerData = CustomerService.getSavedCustomerData(initialValues);
    return __assign(__assign({}, customerData), { smsCode: '' });
};
export default withFormik({
    // @ts-expect-error @TODO add proper props here
    mapPropsToValues: mapPropsToValues,
    validate: validateCustomerFields,
})(VerifyUserModal);
